/**
 * /admin/dashboard — platform stats tiles + recent activity hint.
 */

import { useEffect, useState } from 'react';
import { type PlatformStats, adminApi } from '../admin_api';

function StatTile({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="bg-white rounded-lg border border-[oklch(88%_0.05_70)] p-4">
      <p className="text-xs text-muted-foreground mb-1 uppercase tracking-wide">{label}</p>
      <p className="text-2xl font-semibold num">{value}</p>
    </div>
  );
}

export function AdminDashboard() {
  const [stats, setStats] = useState<PlatformStats | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .getPlatformStats()
      .then(setStats)
      .catch((e: Error) => setError(e.message));
  }, []);

  if (error) {
    return <p className="text-sm text-red-600">Failed to load stats: {error}</p>;
  }
  if (!stats) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }

  return (
    <div>
      <h1 className="text-xl font-semibold mb-6">Platform Dashboard</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatTile label="Total accounts" value={stats.totalAccounts} />
        <StatTile label="Active accounts" value={stats.activeAccounts} />
        <StatTile label="Trial accounts" value={stats.trialAccounts} />
        <StatTile label="Churn this month" value={stats.churnThisMonth} />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <StatTile label="Signups today" value={stats.signupsToday} />
        <StatTile label="Signups this week" value={stats.signupsThisWeek} />
        <StatTile label="Signups this month" value={stats.signupsThisMonth} />
      </div>
    </div>
  );
}
